/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from "../api/mpf-r-lists-http"
import { getBlobStorage, isArchivedFilter } from "./data"

interface QAndA {
  Answer: string
  AssignedComponentCode : number,
  'Category/MetadataValue': any
  CategoryCode: number
  Description: string
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
  Question: string
  'Section/MetadataValue': any
  SectionCode: number
  ServicingMAJCOMCode : number,
  StatusCode: string
  Tags: string
  Title: string
}
interface QAndAArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  Answer: 'Answer',
  AssignedComponent: 'AssignedComponent/MetadataValue',
  AssignedComponentCode: 'AssignedComponentCode',
  Category: 'Category',
  CategoryCodes: 'CategoryCodes',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  Question: 'Question',
  Section: 'Section',
  SectionCodes: 'SectionCodes',
  ServicingMAJCOM: 'ServicingMAJCOM/MetadataValue',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  Squadron: 'Squadron',
  Status: 'Status',
  Tags: 'Tags'
}
const LIST_NAME = 'QAndAList'

const getQAndA = async (
  args: QAndAArgs
): Promise<QAndA[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? false
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemModified
  const items = await list
    .query()
    .select(...Object.values(COLUMN_NAMES))
    .filter(filter)
    .expand(
      'AssignedComponent', 
      'ItemModifiedBy',
      'ItemCreatedBy',
      'ServicingMAJCOM'
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()
    const itemsWithAttachments = await getBlobStorage(LIST_NAME, items)
    
    itemsWithAttachments.forEach((element: QandA) => {
          element.AssignedComponent = element['AssignedComponent/MetadataValue'] || 'All'
          element.ServicingMAJCOM = element['ServicingMAJCOM/MetadataValue'] || 'All'
          element.Category = JSON.parse(element.Category)
          element.Section = JSON.parse(element.Section)
          element.Id = element.eKey,
          element.tags = element.Tags.split(','),
          element.CategoryCodes = JSON.parse(element.CategoryCodes)
          element.SectionCodes = JSON.parse(element.SectionCodes)
        })

  return [...itemsWithAttachments] as QAndA[]
} 

export { COLUMN_NAMES, LIST_NAME, type QAndA, type QAndAArgs, getQAndA }
